import { Type } from '@sinclair/typebox';
import { DebitNormsAccountSchema, DebitNormsSchema } from '../../domain/index.js';
export const GetDebitNormsFromProjectResponseSchema = Type.Array(DebitNormsAccountSchema);
const UpsertDebitNormsSchema = Type.Intersect([
    Type.Omit(DebitNormsSchema, ['id', 'projectId']),
    Type.Object({
        id: Type.Optional(Type.String()),
    }),
]);
export const UpsertDebitNormRequestSchema = Type.Array(UpsertDebitNormsSchema);
